import { temAcesso } from '@/shared/auth/temAcesso'

const Irregularidades = () => import('./Irregularidades.vue')

export default {
    path: 'irregularidades',
    name: 'Irregularidades',
    component: Irregularidades,
    beforeEnter: (to, from, next) => {
        if (temAcesso('FISCALIZACAO-ADMIN')) {
            next()
        }
    }
}